import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { AppCalloutBannerInlineAction } from "@/components/banners/app-callout-banner/app-callout-banner-inline-action";
import type { AppCalloutBannerEventParams } from "@/domains/metrics/tracked-event";
import { MDSText, MDSTextVariant, MDSTextColor } from "@/mds";

interface AppCalloutBannerSecondaryLabelProps {
  label: string;
  inlineActionLabel: string | null;
  inlineActionUrl: string | null;
  trackingContext: AppCalloutBannerEventParams;
}

export const AppCalloutBannerSecondaryLabel: FC<AppCalloutBannerSecondaryLabelProps> = observer(
  ({ label, inlineActionLabel, inlineActionUrl, trackingContext }) => {
    if (!label) return null;

    return (
      <SecondaryLabelText variant={MDSTextVariant.TextS} color={MDSTextColor.Secondary}>
        {label}
        <AppCalloutBannerInlineAction
          label={inlineActionLabel}
          url={inlineActionUrl}
          trackingContext={trackingContext}
        />
      </SecondaryLabelText>
    );
  }
);

const SecondaryLabelText = styled(MDSText)`
  margin-bottom: 8px;
`;
